export const dateForHumans = (isoString, withoutTime, withoutSec) => {
  //   const isoString = "2023-03-24T06:59:13.000+00:00";
  const date = new Date(isoString);

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthsOfYear = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const monthOfYear = monthsOfYear[date.getMonth()];
  const dayOfMonth = date.getDate();
  const year = date.getFullYear();
  const hours = date.getHours() + 1;
  let minutes =
    date.getMinutes() > 10 ? date.getMinutes() : `0${date.getMinutes()}`;
  let seconds =
    date.getSeconds() > 10 ? date.getSeconds() : `0${date.getSeconds()}`;

  if (withoutTime) {
    return `${dayOfWeek} ${monthOfYear} ${dayOfMonth} ${year}`;
  } else if (withoutSec) {
    return `${dayOfWeek} ${monthOfYear} ${dayOfMonth} ${year} ${hours}:${minutes}`;
  } else {
    return `${dayOfWeek} ${monthOfYear} ${dayOfMonth} ${year} ${hours}:${minutes}:${seconds}`;
  }
};
